import type { CondimentAdminDTO } from '@six-pockets/shared';
import { formatINR } from '@/utils/format';
import { RowActions } from './RowActions';
import styles from '@/styles/components/CondimentManageRow/style.scss';

interface CondimentManageRowProps {
  condiment: CondimentAdminDTO;
  onEdit: () => void;
  onDelete: () => void;
}

/** One condiment on the Manage condiments page. */
export function CondimentManageRow({ condiment, onEdit, onDelete }: CondimentManageRowProps) {
  return (
    <tr>
      <td className={styles.name}>{condiment.name}</td>
      <td className={styles.cost}>{formatINR(condiment.costPrice)}</td>
      <td className={styles.money}>{formatINR(condiment.sellingPrice)}</td>
      <td className={styles.data}>{condiment.sortOrder}</td>
      <td>
        <RowActions
          name={condiment.name}
          onEdit={onEdit}
          onDelete={onDelete}
          deleteBlockedReason={condiment.inUse ? 'On an open sale; bill or remove it first' : undefined}
        />
      </td>
    </tr>
  );
}
